var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ImageProcessingSettings" } }, [
    _c("div", { staticClass: "image-processing-settings" }, [
      _c("h2", [_vm._v("Resim İşleme Ayarları")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Chatbot'a gönderilen resimlerin nasıl işleneceğini belirleyin."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "processing-mode" }, [
        _c("strong", [_vm._v("İşleme Modu")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mode-items" },
          [
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: "Block ile İşle",
                    icon: "ChatAiIcon",
                    description: "Resimleri yerel block akışına yönlendir",
                    type: "switch",
                  },
                  model: {
                    value: _vm.imageProcessingBlock,
                    callback: function ($$v) {
                      _vm.imageProcessingBlock = $$v
                    },
                    expression: "imageProcessingBlock",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: "AI ile İşle",
                    icon: "ChatAiIcon",
                    description: "Resimleri yapay zeka ile işle",
                    type: "switch",
                  },
                  model: {
                    value: _vm.imageProcessingAI,
                    callback: function ($$v) {
                      _vm.imageProcessingAI = $$v
                    },
                    expression: "imageProcessingAI",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.imageProcessingBlock && _vm.story.ai
        ? _c("div", { staticClass: "block-processing-settings" }, [
            _c(
              "div",
              { staticClass: "block-selection" },
              [
                _c("strong", [_vm._v("Fallback Block")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Resim işlenirken hata durumunda yönlendirilecek block"
                  ),
                ]),
                _vm._v(" "),
                _c("BlockPicker", {
                  attrs: {
                    "flatted-diagram": _vm.flattedDiagram,
                    placeholder: "Fallback block seçin",
                  },
                  model: {
                    value: _vm.imageFallbackBlockId,
                    callback: function ($$v) {
                      _vm.imageFallbackBlockId = $$v
                    },
                    expression: "imageFallbackBlockId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block-selection" },
              [
                _c("strong", [_vm._v("Direct Jump Block")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Tüm resimleri doğrudan bu block'a yönlendir"),
                ]),
                _vm._v(" "),
                _c("BlockPicker", {
                  attrs: {
                    "flatted-diagram": _vm.flattedDiagram,
                    placeholder: "Direct jump block seçin (opsiyonel)",
                  },
                  model: {
                    value: _vm.imageDirectJumpBlockId,
                    callback: function ($$v) {
                      _vm.imageDirectJumpBlockId = $$v
                    },
                    expression: "imageDirectJumpBlockId",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.imageProcessingAI && _vm.story.ai
        ? _c("div", { staticClass: "ai-processing-settings" }, [
            _c("div", { staticClass: "ai-mode" }, [
              _c("strong", [_vm._v("AI İşleme Modu")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mode-items" },
                [
                  _vm.story.ai
                    ? _c("FeatureItem", {
                        attrs: {
                          title: "Tek Tek İşle",
                          icon: "ChatAiIcon",
                          description: "Her resimi ayrı ayrı AI'ya gönder",
                          type: "switch",
                        },
                        model: {
                          value: _vm.aiProcessingIndividual,
                          callback: function ($$v) {
                            _vm.aiProcessingIndividual = $$v
                          },
                          expression: "aiProcessingIndividual",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.story.ai
                    ? _c("FeatureItem", {
                        attrs: {
                          title: "Paralel İşle",
                          icon: "ChatAiIcon",
                          description:
                            "Belirli süre içindeki resimleri topla ve birlikte gönder",
                          type: "switch",
                        },
                        model: {
                          value: _vm.aiProcessingParallel,
                          callback: function ($$v) {
                            _vm.aiProcessingParallel = $$v
                          },
                          expression: "aiProcessingParallel",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.aiProcessingParallel
              ? _c(
                  "div",
                  { staticClass: "buffer-time-setting" },
                  [
                    _vm.story.ai
                      ? _c("FeatureItem", {
                          attrs: {
                            title: "Buffer Süresi (saniye)",
                            icon: "ChatAiIcon",
                            description:
                              "Resimlerin toplanması için beklenecek süre",
                            type: "number",
                            min: 5,
                            max: 120,
                            step: 5,
                            "number-format": "integer",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.changeImageBufferTime(
                                _vm.imageBufferTime
                              )
                            },
                            increase: function ($event) {
                              return _vm.changeImageBufferTime(
                                _vm.imageBufferTime
                              )
                            },
                            decrease: function ($event) {
                              return _vm.changeImageBufferTime(
                                _vm.imageBufferTime
                              )
                            },
                          },
                          model: {
                            value: _vm.imageBufferTime,
                            callback: function ($$v) {
                              _vm.imageBufferTime = $$v
                            },
                            expression: "imageBufferTime",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-btn" },
        [
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("İptal")]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.saveSettings } },
            [_vm._v("Kaydet")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }